import React from 'react';
import CotizadorForm2 from './components/CotizadorForm2.jsx';
import { CotizadorWizzard } from './components/CotizadorWizzard.jsx';
import { BrowserRouter as Router,  Switch,  Route,  Link } from "react-router-dom";
import Redux from './components/Redux.jsx';
import {Provider} from 'react-redux';
import generateStore from './redux/store';
import Crud from './components/Crud.jsx';
import Objeto from './components/Objeto.jsx';
import Buentrabajo from './components/Buentrabajo.jsx';
import InformeEnviado from './components/InformeEnviado.jsx';
import PendienteDePago from './components/PendienteDePago.jsx';
import Error from './components/Error.jsx';
import EnviarParametros from './components/ActualizarParametros.jsx';
import Exportar from './components/exportar.jsx';
function App() { 

  const store = generateStore()

  return (

    <Router>
  

      <Switch>
          <Route path="/cotizador" exact>
              <CotizadorForm2 />
          </Route>

          <Route path="/wizzard">
              <CotizadorWizzard />
          </Route>
          
          <Route path="/form">
              <CotizadorForm2 />
          </Route>

          <Route path="/crud">
              <Crud />
          </Route>

          <Route path="/redux">
              <Provider store = {store}>
                  <Redux />
              </Provider>              
          </Route>
          
          <Route path="/objeto">
              <Objeto/>
          </Route>

          <Route path="/buentrabajo">
              <Buentrabajo/>
          </Route>

          <Route path="/informeenviado">
              <InformeEnviado/>
          </Route>

          <Route path="/pendientedepago">
              <PendienteDePago/>
          </Route>

          <Route path="/error">
              <Error/>
          </Route>
          <Route path="/enviarparametros">
              <EnviarParametros/>
          </Route>
          <Route path="/exportar">
              <Exportar/>
          </Route>          
      </Switch>

    </Router>

);} 

export default App;